export default "__VITE_ASSET__Def0_dDE__"